<style lang="scss" scoped>
  .form__in .inline select {
    border-radius: 0.4rem;
    padding: 1.2rem 1rem;
    border: none;
    color: #616161;
    background: #F5F5F5;
    font-size: 1.4rem;
    font-weight: 501;
    -webkit-appearance: auto !important;
  }
</style>

<template>
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="sign__page">
          <div class="form">
            <ul class="form__ul">
              <li class="form__li m20">
                <div class="form__ttl">서비스 선택</div>
                <div class="form__in">
                  <div class="inline">
                    <label class="input">
                      <select>
                        <option>전력비 절감</option>
                        <option>노무, 인증</option>
                        <option>연구소</option>
                      </select>
                    </label>
                  </div>
                </div>
              </li>
              <li class="form__li m20">
                <div class="form__ttl">제목</div>
                <div class="form__in">
                  <div class="inline">
                    <label class="input">
                      <input type="text" placeholder="제목을 입력해주세요." v-model="inquireDetail.boardTitle">
                    </label>
                  </div>
                </div>
              </li>
              <li class="form__li m20">
                <div class="form__ttl">내용</div>
                <div class="form__in">
                  <div class="inline">
                    <label class="input">
                      <textarea placeholder="문의에 따라 답변 소요 시간이 길어질 수 있습니다." v-model="inquireDetail.boardDescription"></textarea>
                    </label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="btn_wrap btn_wrap__fixed">
        <button class="btm on" @click="fnSave">문의 등록</button> <!--활성화: on-->
      </div>
    </div>
  </main>
</template>
<script>
export default {
  data: function () {
    return {
      isShow: false,
      params: {
        boardNo: this.$route.query.boardNo
      },
      inquireDetail: {
        userNo: this.$store.getters['account/getUserData'].userNo,
        boardTitle: '',
        boardDescription: ''
      }
    }
  },
  created: function () {
    this.getInquireDetail()
  },
  computed: {
    userData: function () {
      return this.$store.getters['account/getUserData']
    }
  },
  methods: {
    getInquireDetail: function () {
      if(this.params.boardNo > 0) {
        this.$MypageSvc.getBoardDetail(this.params)
          .then(res => {
            const code = res.code
            const message = res.message
            const entity = res.entity

            console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))
            if (code === 1) {
              this.isShow = true
              this.inquireDetail = entity
            }
          })
      }
    },
    fnSave: function () {
      if (this.inquireDetail.boardTitle.length <= 0) {
        this.$Util.modalAlert({message: '제목을 입력해주세요.'})
        return false
      }
      if (this.inquireDetail.boardDescription.length <= 0) {
        this.$Util.modalAlert({message: '내용을 입력해주세요.'})
        return false
      }
      const _this = this
      if(this.params.boardNo > 0) {
        this.$MypageSvc.modifyInquire(this.inquireDetail)
          .then(res => {
            const code = res.code
            const message = res.message
            const entity = res.entity

            console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))
            if (code === 1) {
              this.$Util.modalAlert({message: '문의사항이 등록되었습니다.'}, function () {
                setTimeout(function () {
                  _this.$router.go(-1)
                }, 200)
              })
            } else {
              this.$Util.modalAlert({message: message})
            }
          })
      } else {
        this.$MypageSvc.saveInquire(this.inquireDetail)
          .then(res => {
            const code = res.code
            const message = res.message
            const entity = res.entity

            console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))
            if (code === 1) {
              this.$Util.modalAlert({message: '문의사항이 등록되었습니다.'}, function () {
                setTimeout(function () {
                  _this.$router.go(-1)
                }, 200)
              })
            } else {
              this.$Util.modalAlert({message: message})
            }
          })
      }
    }
  }
}
</script>
